import { render, staticRenderFns } from "./VIPList.vue?vue&type=template&id=0718d182"
import script from "./VIPList.vue?vue&type=script&lang=js"
export * from "./VIPList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports